module.exports = __webpack_public_path__ + "static/media/sort-descending.d330f81c.svg";